/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowUpdateMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  softwareEscrowParams: Types.ISoftwareEscrowUpdateParams;
}>;

export type ISoftwareEscrowUpdateMutation = {
  __typename?: 'Mutation';
  softwareEscrowUpdate?: {
    __typename?: 'SoftwareEscrowUpdatePayload';
    success: boolean;
    errors?: Array<string> | null;
    softwareEscrow?:
      | {
          __typename?: 'SaasEscrow';
          id: string;
          activationNotification: boolean;
          beneficiaryActivityNotification: Types.ActivityNotificationEnum;
          beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
          beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
          beneficiarySharedInformation: boolean;
          depositorActivityNotification: Types.ActivityNotificationEnum;
          depositorDisruptionNotification: Types.DisruptionNotificationEnum;
          depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
          storageRegion?: string | null;
          assetVersionsLimit?: number | null;
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          activationNotification: boolean;
          beneficiaryActivityNotification: Types.ActivityNotificationEnum;
          beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
          beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
          beneficiarySharedInformation: boolean;
          depositorActivityNotification: Types.ActivityNotificationEnum;
          depositorDisruptionNotification: Types.DisruptionNotificationEnum;
          depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
          storageRegion?: string | null;
          assetVersionsLimit?: number | null;
        }
      | null;
  } | null;
};

export const SoftwareEscrowUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'softwareEscrowUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SoftwareEscrowUpdateParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'softwareEscrowUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softwareEscrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activationNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryActivityNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotificationGracePeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiarySharedInformation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorActivityNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotificationGracePeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'storageRegion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetVersionsLimit' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISoftwareEscrowUpdateMutation, ISoftwareEscrowUpdateMutationVariables>;
